<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form ref="formData" :model="formData" :inline="true" label-width="100px" class="formInline" size="mini">
          <el-form-item label="公司名称" prop="company">
            <el-select v-model="formData.company" filterable placeholder="请选择公司名称...">
              <el-option label="全部" :value="null"></el-option>
              <el-option v-for="item in companiesAll" :label="item.name" :key="item.code"
                         :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="待置换供应商" prop="originSupplier">
            <el-select v-model="formData.originSupplier" filterable placeholder="请选择待置换供应商...">
              <el-option label="全部" :value="null"></el-option>
              <el-option v-for="item in suppliersAll" :label="item.name" :key="item.code"
                         :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当前供应商" prop="permuteSupplier">
            <el-select v-model="formData.permuteSupplier" filterable placeholder="请选择当前供应商...">
              <el-option label="全部" :value="null"></el-option>
              <el-option v-for="item in suppliersAll" :label="item.name" :key="item.code"
                         :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="formData.status" filterable placeholder="请选择状态...">
              <el-option label="全部" :value="null"></el-option>
              <el-option :label="'生效中'" :value="1"></el-option>
              <el-option :label="'已关闭'" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <hr style="margin-bottom: 9px;">
          <div class="slide-btns clearfix">
            <el-form-item>
              <el-button type="text" class="reset-btn" @click="resetForm">清空</el-button>
              <el-button class="search-btn" @click="searchForm">筛选</el-button>
              <el-button v-if="editAuth" class="search-btn" @click="addDialog" style="margin-left: 0px;">新增</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table :data="tableData" size="small" v-loading="listLoading" element-loading-text="拼命加载中" border
                  header-row-class-name="table-header">
          <el-table-column type="index" label="#" align="center"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center"></el-table-column>
          <el-table-column prop="originSupplierName" label="待置换供应商" align="center"></el-table-column>
          <el-table-column prop="permuteSupplierName" label="当前供应商" align="center"></el-table-column>
          <el-table-column prop="permuteBank" label="当前供应商开户行" align="center"></el-table-column>
          <el-table-column prop="permuteBankAccount" label="当前供应商银行账号" align="center"></el-table-column>
          <el-table-column prop="creationTime" label="生效时间" align="center"></el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">已关闭</div>
              <div v-if="scope.row.status == 1">生效中</div>
            </template>
          </el-table-column>
          <el-table-column prop="closeTime" label="关闭时间" align="center"></el-table-column>
          <el-table-column prop="operatorAccount" label="操作人账号" align="center"></el-table-column>
          <el-table-column prop="operatorName" label="操作人姓名" align="center"></el-table-column>
          <el-table-column v-if="editAuth" label="操作" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color: #1652ff; cursor: pointer;"
                    @click="showEdit(scope.row.id, scope.row.companyName)">修改</span>
              <span v-if="scope.row.status == 1" style="color: #1652ff; cursor: pointer;" @click="close(scope.row.id)">关闭</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="formData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!--新增供应商置换弹出窗-->
    <el-dialog :title="'供应商置换'" :visible.sync="showAddDialog" width="40%" center>
      <hr style="margin-bottom: 9px">
      <div class="add-select" style="text-align: center; margin-top: 50px;">
        <el-form ref="addData" :model="addData" label-width="200px" size="small"
                 label-position="left">
          <el-form-item label="公司名称" required="true">
            <el-select v-model="addData.company" value-key="code" filterable placeholder="请选择公司名称..." clearable
                       @change="searchCompanySuppliers" @clear="addData.originSupplier = null">
              <el-option v-for="item in companiesAll" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="待置换供应商" required="true">
            <el-select v-model="addData.originSupplier" value-key="code" filterable placeholder="请选择待置换供应商..."
                       clearable>
              <el-option v-for="item in companySuppliers" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="置换后供应商" required="true">
            <el-select v-model="addData.permuteSupplier" value-key="code" filterable placeholder="请选择置换后供应商..."
                       clearable @change="searchOpenBanks"
                       @clear="addData.permuteBank = null,addData.permuteBankAccount = null">
              <el-option v-for="item in suppliersAll" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="置换后供应商开户行" required="true">
            <el-select v-model="addData.permuteBank" filterable placeholder="请选择置换后供应商开户行..." clearable
                       @change="searchOpenBankNos" @clear="addData.permuteBankAccount = null">
              <el-option v-for="item in openBanks" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="置换后供应商银行账号" required="true">
            <el-select v-model="addData.permuteBankAccount" filterable placeholder="请选择置换后供应商银行账号..." clearable>
              <el-option v-for="item in openBankNos" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="add">确定</el-button>
          <el-button class="search-btn" @click="showAddDialog=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--供应商置换明细弹出框-->
    <el-dialog :title="detailCompany" :visible.sync="showDetailDialog" width="80%" center>
      <hr style="margin-bottom: 10px">
      <div class="add-select" style="text-align: center; margin-top: 20px;">
        <el-table :data="detailsData" size="small" v-loading="listLoading" element-loading-text="拼命加载中" border
                  header-row-class-name="table-header">
          <el-table-column type="index" label="#" align="center"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center"></el-table-column>
          <el-table-column prop="originSupplierName" label="原供应商" align="center"></el-table-column>
          <el-table-column prop="permuteSupplierName" label="当前供应商" align="center"></el-table-column>
          <el-table-column prop="permuteBank" label="当前供应商开户行" align="center"></el-table-column>
          <el-table-column prop="permuteBankAccount" label="当前供应商银行账号" align="center"></el-table-column>
          <el-table-column prop="creationTime" label="生效时间" align="center"></el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">已关闭</div>
              <div v-if="scope.row.status == 1">生效中</div>
            </template>
          </el-table-column>
          <el-table-column prop="closeTime" label="关闭时间" align="center"></el-table-column>
          <el-table-column prop="operatorName" label="操作人姓名" align="center"></el-table-column>
          <el-table-column v-if="editAuth" label="操作" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1 && scope.row.lastNode == 1" style="color: #1652ff; cursor: pointer;"
                    @click="showAddDetail(scope.row.id, scope.row.permuteSupplierName)">置换</span>
              <span v-else-if="scope.row.status == 1 && scope.row.lastNode == 0">置换</span>
              <span v-if="scope.row.status == 1 && scope.row.lastNode == 1" style="color: #1652ff; cursor: pointer;"
                    @click="showCloseDetail(scope.row.id)">关闭</span>
              <span v-else-if="scope.row.status == 1 && scope.row.lastNode == 0">关闭</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="showDetailDialog = false">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!--新增供应商置换明细弹出框-->
    <el-dialog :title="'供应商置换'" :visible.sync="showAddDetailDialog" width="40%" center>
      <hr style="margin-bottom: 9px">
      <div class="add-select" style="text-align: center; margin-top: 50px;">
        <el-form ref="addDetailData" :model="addDetailData" label-width="200px" size="small"
                 label-position="left">
          <el-form-item label="公司名称">
            <p>{{detailCompany}}</p>
          </el-form-item>
          <el-form-item label="当前供应商">
            <p>{{currentDetailSupplier}}</p>
          </el-form-item>
          <el-form-item label="置换后供应商" required="true">
            <el-select v-model="addDetailData.permuteSupplier" value-key="code" filterable placeholder="请选择置换后供应商..."
                       clearable @change="searchDetailOpenBanks"
                       @clear="addDetailData.permuteBank = null,addDetailData.permuteBankAccount = null">
              <el-option v-for="item in suppliersAll" :label="item.name" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="置换后供应商开户行" required="true">
            <el-select v-model="addDetailData.permuteBank" filterable placeholder="请选择置换后供应商开户行..." clearable
                       @change="searchDetailOpenBankNos" @clear="addDetailData.permuteBankAccount = null">
              <el-option v-for="item in openBanks" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="置换后供应商银行账号" required="true">
            <el-select v-model="addDetailData.permuteBankAccount" filterable placeholder="请选择置换后供应商银行账号..." clearable>
              <el-option v-for="item in openBankNos" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="addDetail">确定</el-button>
          <el-button class="search-btn" @click="showAddDetailDialog=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'

  export default {
    data() {
      return {
        companiesAll: [],
        suppliersAll: [],
        companySuppliers: [],
        openBanks: [],
        openBankNos: [],
        formData: {
          pageNo: 1,
          pageSize: 10,
          company: null,
          originSupplier: null,
          permuteSupplier: null,
          status: null
        },
        addData: {
          company: null,
          originSupplier: null,
          permuteSupplier: null,
          permuteBank: null,
          permuteBankAccount: null
        },
        tableData: [],
        total: null,
        listLoading: false,
        showAddDialog: false,
        editAuth: false,
        showDetailDialog: false,
        detailCompany: null,
        detailConfigId: null,
        detailsData: [],
        currentDetailSupplier: null,
        showAddDetailDialog: false,
        addDetailData: {
          id: null,
          permuteSupplier: null,
          permuteBank: null,
          permuteBankAccount: null
        }
      }
    },
    mounted() {
      this.getEditCustomerConfigAuth();
      this.searchCompaniesAll();
      this.searchSuppliersAll();
      this.getData();
    },
    methods: {
      getData() {
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/list',
          params: this.formData
        }).then(res => {
          this.tableData = res.data.data.items;
          this.total = res.data.data.totalItemsCount;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      searchCompaniesAll() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/companies-all'
        }).then(res => {
          this.companiesAll = res.data.data
        }).catch(err => {
        })
      },
      searchSuppliersAll() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/suppliers-all'
        }).then(res => {
          this.suppliersAll = res.data.data
        }).catch(err => {
        })
      },
      searchCompanySuppliers() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/company/suppliers',
          params: {
            companyCode: this.addData.company.code
          }
        }).then(res => {
          this.companySuppliers = res.data.data;
        }).catch(err => {
        })
      },
      searchOpenBanks() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/open-banks',
          params: {
            supplierId: this.addData.permuteSupplier.code
          }
        }).then(res => {
          this.openBanks = res.data.data;
        }).catch(err => {
        })
      },
      searchOpenBankNos() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/open-bank-nos',
          params: {
            supplierId: this.addData.permuteSupplier.code,
            openBank: this.addData.permuteBank
          }
        }).then(res => {
          this.openBankNos = res.data.data;
        }).catch(err => {
        })
      },
      searchForm() {
        this.formData.pageSize = 10;
        this.formData.pageNo = 1;
        this.getData();
      },
      resetForm() {
        this.$refs['formData'].resetFields();
      },
      handleSizeChange(val) {
        this.formData.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val;
        this.getData();
      },
      addDialog() {
        this.clearAddData();
        this.showAddDialog = true;
      },
      clearAddData() {
        this.addData = {
          companyCode: null,
          companyName: null,
          originSupplierId: null,
          originSupplierName: null,
          permuteSupplierId: null,
          permuteSupplierName: null,
          permuteBank: null,
          permuteBankAccount: null
        };
      },
      add() {
        if (!this.addData.company || !this.addData.company.code || !this.addData.company.name || !this.addData.originSupplier || !this.addData.originSupplier.code
          || !this.addData.originSupplier.name || !this.addData.permuteSupplier || !this.addData.permuteSupplier.code || !this.addData.permuteSupplier.name || !this.addData.permuteBank || !this.addData.permuteBankAccount) {
          alert("参数填写不完整！");
          return;
        }
        var permuteData = {
          companyCode: this.addData.company.code,
          companyName: this.addData.company.name,
          originSupplierId: this.addData.originSupplier.code,
          originSupplierName: this.addData.originSupplier.name,
          permuteSupplierId: this.addData.permuteSupplier.code,
          permuteSupplierName: this.addData.permuteSupplier.name,
          permuteBank: this.addData.permuteBank,
          permuteBankAccount: this.addData.permuteBankAccount
        };
        this.listLoading = true;
        this.$http({
          method: 'POST',
          url: '/rest/supplier-permute/add',
          data: permuteData
        }).then(res => {
          this.clearAddData();
          this.showAddDialog = false;
          this.listLoading = false;
          if (res.data.code == '0' && res.data.status == 200) {
            this.getData()
            utils.myNotify(this, 'success', res, '操作成功')
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          this.listLoading = false;
          utils.myNotify(this, "error", res, '操作失败');
        })
      },
      close(id) {
        this.$confirm('是否确认关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          this.$http({
            method: "POST",
            url: '/rest/supplier-permute/close',
            params: {
              id: id
            }
          }).then(res => {
            this.listLoading = false;
            if (res.data.code == '0' && res.data.status == 200) {
              this.getData()
              utils.myNotify(this, 'success', res, '操作成功')
            } else {
              utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
            }
          }).catch(err => {
            this.listLoading = false;
            utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          })
        }).catch(() => {
        })
      },
      getEditCustomerConfigAuth() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/edit-auth'
        }).then(res => {
          this.editAuth = res.data.data
        }).catch(err => {
        })
      },
      showEdit(id, company) {
        this.detailConfigId = id;
        this.detailCompany = company;
        this.showDetailDialog = true;
        this.getDetailList(id);
      },
      getDetailList(id) {
        this.listLoading = true;
        this.$http({
          method: "GET",
          url: '/rest/supplier-permute/detail-list',
          params: {
            id: id
          }
        }).then(res => {
          this.listLoading = false;
          if (res.data.code == '0' && res.data.status == 200) {
            this.detailsData = res.data.data;
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          this.listLoading = false;
          utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
        })
      },
      showAddDetail(id, currentDetailSupplier) {
        this.currentDetailSupplier = currentDetailSupplier;
        this.clearDetailData();
        this.addDetailData.id = id;
        this.showAddDetailDialog = true;
      },
      searchDetailOpenBanks() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/open-banks',
          params: {
            supplierId: this.addDetailData.permuteSupplier.code
          }
        }).then(res => {
          this.openBanks = res.data.data;
        }).catch(err => {
        })
      },
      searchDetailOpenBankNos() {
        this.$http({
          method: 'GET',
          url: '/rest/supplier-permute/open-bank-nos',
          params: {
            supplierId: this.addDetailData.permuteSupplier.code,
            openBank: this.addDetailData.permuteBank
          }
        }).then(res => {
          this.openBankNos = res.data.data;
        }).catch(err => {
        })
      },
      addDetail() {
        if (!this.addDetailData.id || !this.addDetailData.permuteSupplier || !this.addDetailData.permuteSupplier.code || !this.addDetailData.permuteSupplier.name || !this.addDetailData.permuteBank || !this.addDetailData.permuteBankAccount) {
          alert("参数填写不完整！");
          return;
        }
        var detailData = {
          id: this.addDetailData.id,
          permuteSupplierId: this.addDetailData.permuteSupplier.code,
          permuteSupplierName: this.addDetailData.permuteSupplier.name,
          permuteBank: this.addDetailData.permuteBank,
          permuteBankAccount: this.addDetailData.permuteBankAccount
        };
        this.listLoading = true;
        this.$http({
          method: 'POST',
          url: '/rest/supplier-permute/detail/add',
          data: detailData
        }).then(res => {
          this.clearDetailData();
          this.showAddDialog = false;
          this.listLoading = false;
          if (res.data.code == '0' && res.data.status == 200) {
            this.showAddDetailDialog = false;
            this.getDetailList(this.detailConfigId);
            this.getData();
            utils.myNotify(this, 'success', res, '操作成功')
          } else {
            utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
          }
        }).catch(err => {
          this.listLoading = false;
          utils.myNotify(this, "error", err.response, '操作失败');
        })
      },
      clearDetailData() {
        this.addDetailData = {
          id: null,
          originSupplier: null,
          permuteSupplier: null,
          permuteBank: null,
          permuteBankAccount: null
        };
      },
      showCloseDetail(id) {
        this.$confirm('是否确认关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          this.$http({
            method: "POST",
            url: '/rest/supplier-permute/detail/close',
            params: {
              id: id
            }
          }).then(res => {
            this.listLoading = false;
            if (res.data.code == '0' && res.data.status == 200) {
              this.getDetailList(this.detailConfigId);
              this.getData();
              utils.myNotify(this, 'success', res, '操作成功')
            } else {
              utils.myNotify(this, 'error', res, '操作失败，请稍后重试')
            }
          }).catch(err => {
            this.listLoading = false;
            utils.myNotify(this, "error", err.response, '操作失败，请稍后重试')
          })
        }).catch(() => {
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .search-btn {
    margin-left: 30px;
    margin-right: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/views/workSquare/supplierPermute.vue